/** The live building-height controls are only shown to the named developer. */
export const canTuneBuildingHeight = (name?: string): boolean => name === "Aron" || name === "aron"

let buildingHeightTuningEnabled = false

export const isBuildingHeightTuningEnabled = (name?: string): boolean =>
    buildingHeightTuningEnabled && canTuneBuildingHeight(name)

export const toggleBuildingHeightTuning = (name?: string): void => {
    if (canTuneBuildingHeight(name)) buildingHeightTuningEnabled = !buildingHeightTuningEnabled
}
